import React from 'react'
import { View, Text, TouchableOpacity, ActivityIndicator } from 'react-native'
import { styles } from '../styles'
import { darkLightColor } from '../../../theme/colors'
import { useTranslation } from 'react-i18next'

interface Props {
  isLoading: boolean
  onPress: () => void
  title: 'AGUA DULCE' | 'AGUA MAR' | 'SALUD' | 'LOGISTICA'
  icon: () => React.JSX.Element
}

export const Card = ({ isLoading, onPress, title, icon }: Props) => {
  const { t } = useTranslation()
  return (
    <TouchableOpacity
      disabled={isLoading}
      activeOpacity={0.9}
      onPress={onPress}
      style={styles.cardContainer}
    >
      <View style={{ flexDirection: 'row', gap: 16 }}>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'flex-end' }}>
          {isLoading ? <ActivityIndicator size={50} color={darkLightColor} /> : icon()}
        </View>
        <View style={[{ flex: 2, padding: 7 }]}>
          <View>
            <Text style={styles.title}>{t(title)}</Text>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  )
}
